/**
 * @generated SignedSource<<904f5782178edd19d0b8b86a4cfec6db>>
 * @relayHash 501dc43e5d864944f4aed4e0000b867e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3c2ad352cfe62153baddcba1d5fcfdf047fefa1395e9d51c2cba798a836a5e0b

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { mainIssueAggQuery } from './mainIssueAggQuery.graphql';

const node: PreloadableConcreteRequest<mainIssueAggQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "3c2ad352cfe62153baddcba1d5fcfdf047fefa1395e9d51c2cba798a836a5e0b",
    "metadata": {},
    "name": "mainIssueAggQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
